import React from 'react'
import ReactCountDown from 'react-countdown'
import { RoundedCountDown } from './CountDown.style'

export const CountDown = props => {
  if (!props.date) {
    return null
  }

  const dt = new Date(props.date)
  return (
    <ReactCountDown
      date={dt}
      renderer={res => {
        const { days, hours, minutes, seconds } = res
        if (
          (days === null || days === 0) &&
          (hours === null || hours === 0) &&
          (minutes === null || minutes === 0)
        ) {
          return null
        }

        return (
          <RoundedCountDown className={props.className || ''} {...res}>
            დარჩა:
            <i>
              {days !== null && days !== 0 && `${days} დღე `}
              {hours !== null && hours !== 0 && `${hours} საათი `}
              {minutes !== null && minutes !== 0 && `${minutes} წუთი `}
            </i>
          </RoundedCountDown>
        )
      }}
    />
  )
}

export default CountDown
